import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_QUERY_TYPES } from "src/api-setup/api-endpoints";

export const getQueryTypes = async (cookiesData, dispatch, seletedProvider) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_conversation_user_key: seletedProvider || "",
      in_sort_number: 2,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_QUERY_TYPES, null, apiHeaders, requestBody, dispatch);
    if (response && response.data && response.data.row_result) {
      return response?.data.row_result;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
